module.exports = __webpack_public_path__ + "img/workout-notebook_B095QCJB3G.19e5e82d.jpg";